<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li class="active">风电振动监测</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">风电振动监测</h1>
            <hr>
            <p class="titleP">风电机组监测概述</p>
            <p>风电场设备常年在野外运行，机组经常工作在沙尘、冰雪、雷电、风暴等恶劣的环境下，所以风力发电机所受外部激振力和振动自由度相对其他大型旋转机械要多，长期以来，振动是风力发电机组运行中最常见的主要故障之一，又是原因最复杂、最不容易解决的问题，严重时会形成振动事故，造成设备损害。风力发电机运行是否正常直接影响着风力发电的产量，风机故障可能会导致机组本身的损坏，甚至有可能造成更严重的后果。为了保证风力发电机组稳定运行和高效的利用风力资源，有必要对风力发电机组振动进行监测；为了保障风机的安全运行，对其运行状况进行振动状态监测与故障诊断非常重要。</p>
            <p class="titleP">对风电塔筒和塔架固有频率测试</p>
            <p>塔筒和塔架是风力发电系统中的支承装置，与基础相连，承受风力发电系统运行引起的各种载荷，同时将这些载荷传递到基础。对于大型风力发电机组，其塔架高度一般都在数十米，其设计水平直接影响风力发电机的工作性能和可靠性，在设计时还必须考虑塔筒与叶轮是否会发生共振，因此塔筒和塔架模态频率是塔筒测试的重要内容。</p>
            <p class="titleP">测试硬件设备</p>
<!--            <img src="../../../assets/center/wind/t1.png" alt="">-->
            <table border="1" style="text-align:center;">
              <tr>
                <th><p>产品型号</p></th>
                <th><p>产品概述</p></th>
              </tr>
              <tr>
                <td><p>D3000型动态数据采集仪</p></td>
                <td><p>物联网型振动数据采集仪，适用于风机塔筒和塔架结构的振动长期监测</p></td>
              </tr>
              <tr>
                <td><p>BY-S07型低频振动传感器</p></td>
                <td><p>频率范围：0.14~100Hz，四档选择，可直接测速度/加速度（单向/双向/三向），防护等级IP67</p></td>
              </tr>
              <tr>
                <td><p>QYM倾角仪</p></td>
                <td><p>能精确测量静态倾斜度，也能测量动态倾斜度</p></td>
              </tr>
            </table>
            <p>系统特点：</p>
            <p>1.采集仪：D3000型动态数据采集仪采用独立24bitADC并行同步采集，动态范围可达120db以上，设备可级联扩展至128通道，采用直流适配器15V供电，也支持外接直流电池（蓄电池）供电，有外部供电时时使用外部供电，并给内置电池供电，无外部供电时，自动切换至内置电池供电，内置TF储存卡，在自然灾害来临（断电/断网），仪器仍正常工作，数据储存至TF卡中，保证数据采集的连续性。采集仪开放底层协议，可使用C语言、Python语言等进行对接，还可对接用户的监测平台。
              2. 传感器：传感器使用了无源伺服反馈技术，输出模拟电压信号，宽频带、高分辨率、大动态范围、抗冲击性能好，可直接与数据采集仪配接。传感器可在恶劣环境下工作，-40℃~+85℃。耐潮耐湿，防护等级IP67。QYM 系列倾角仪为大量程、高精度的单分量和二分量倾斜度测试传感器， 采用微机电技术作的高精度差动电容为敏感元件，可用于测试桥墩、桥梁、桥塔、 楼房、风力发电站基础塔等结构的一维和二维动态倾斜度的测量及监测
            </p>
            <p class="titleP">风电机组振动监测流程图</p>
            <img src="../../../assets/center/wind/f1.png" alt="">
<!--            <p class="titleP">风机塔筒振动监测案例</p>-->
<!--            <p>公司在某地进行风机塔筒振动监测</p>-->
<!--            <img src="../../../assets/center/wind/c1.png" alt="">-->
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/wind/wind.vue